// extracted by mini-css-extract-plugin
export var backgroundContainer = "Column2BulletGrid-module--backgroundContainer--ae7f8";
export var backgroundImage = "Column2BulletGrid-module--backgroundImage--b5439";
export var compact = "Column2BulletGrid-module--compact--e661a";
export var compactGrid = "Column2BulletGrid-module--compactGrid--7f39d";
export var content = "Column2BulletGrid-module--content--fa1c5";
export var description = "Column2BulletGrid-module--description--600e5";
export var grid = "Column2BulletGrid-module--grid--ceb70";
export var hasImage = "Column2BulletGrid-module--hasImage--b00ef";
export var hasSpace = "Column2BulletGrid-module--hasSpace--a81c9";
export var heading = "Column2BulletGrid-module--heading--a5664";
export var headingLink = "Column2BulletGrid-module--headingLink--6777b";
export var horizontalLayout = "Column2BulletGrid-module--horizontalLayout--46791";
export var image = "Column2BulletGrid-module--image--105e3";
export var item = "Column2BulletGrid-module--item--eec92";
export var learnMore = "Column2BulletGrid-module--learnMore--dadc5";
export var root = "Column2BulletGrid-module--root--c8c43";
export var verticalLayout = "Column2BulletGrid-module--verticalLayout--f5935";